import React, { useState, useEffect } from 'react';
import './PhoneVerification.css';

const PhoneVerification = ({ currentPhone, onVerificationComplete }) => {
  const [phoneNumber, setPhoneNumber] = useState(currentPhone || '');

  // Only set initial value from props, don't update on prop changes
  useEffect(() => {
    if (currentPhone && !phoneNumber) {
      setPhoneNumber(currentPhone);
    }
  }, []); // Empty dependency array - only run on mount

  const handlePhoneChange = (e) => {
    const newPhone = e.target.value;
    setPhoneNumber(newPhone);
    
    // Update parent component with new phone number
    if (onVerificationComplete) {
      onVerificationComplete({
        phoneNumber: newPhone
      });
    }
  };

  return (
    <div className="phone-verification-container">
      <div className="form-group">
        <label>Phone Number (for MVola payments)</label>
        <input
          type="tel"
          value={phoneNumber}
          onChange={handlePhoneChange}
          placeholder="0341234567"
          maxLength={10}
          className="phone-input"
        />
        <small>Enter your MVola phone number</small>
      </div>
    </div>
  );
};

export default PhoneVerification;
